import React from 'react';
interface FormFieldProps {
  label: string;
  htmlFor: string;
  required?: boolean;
  hint?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}
export function FormField({
  label,
  htmlFor,
  required,
  hint,
  className = '',
  children
}: FormFieldProps) {
  return <div className={className} data-id="element-18" data-mp="3mgq6d3nkwq8u">
      <label htmlFor={htmlFor} className="mb-1.5 flex items-center gap-1 text-[13px] font-medium text-slate-700" data-id="element-19" data-mp="3mi186xxgrnxb">
        {label}
        {required && <span className="text-coral-600" aria-hidden="true" data-id="element-20" data-mp="j09ar40k6brq">
            *
          </span>}
      </label>
      {children}
      {hint && <div className="mt-1.5 text-xs text-slate-500" data-id="element-21" data-mp="41ywn8kvmx2g">{hint}</div>}
    </div>;
}